import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactGA from 'react-ga4';

import "../../App.css";
import "../../general.css";
import "../../queries.css";

import f_u from "../../assets/images/F_u-da85151b.jpeg";
import f_u2 from "../../assets/images/F_u.jpeg";
import our_story from "../../assets/images/our_story-7821170e.jpg";
import our_story2 from "../../assets/images/our_story.jpg";
import szilvi_2023 from "../../assets/images/Szilvi_2023.webp";
import balint_2023 from "../../assets/images/Balint_2019.webp";
import akos_2023 from "../../assets/images/Akos_2023.webp";

import SectionFadeIn from "../../components/SectionFadeIn"

type QuestProps = {
  isSubpage?: boolean; // alapértelmezett: false
};

function Quest({ isSubpage = false }: QuestProps) {

  useEffect(() => {
    if (!isSubpage) {
      ReactGA.send({
        category: "Scroll",
        action: "Reached Section",
        label: "section-quest",
      });
    }
  }, [isSubpage]);

  useEffect(() => {
    console.log(windowWidth);
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  return (
    <motion.main
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      
    <SectionFadeIn delay={0.2}>
      <section className="section-quest"  id="quest">
        <div className="container-mainsite">
          <h2>
            <div className="section-title" style={{display: isSubpage ? "flex" : "none"}}>
              <span className="heading-secondary light">The Playbook</span>
            </div>
          </h2>
          <div className="container-spacebetween">              
              <div className="quest-card5 flip-card2" style={{aspectRatio: windowWidth < 600 ? "1066/1800" : "13 / 16"}}>
                <div className="flip-card-inner2" >
                  <div className="quest-card-front2 flip-card-front2">
                    <img className="card-image2 card-photo" src={windowWidth < 600 ? f_u2 : f_u} alt="" />
                    <div className="heading-wrap quest-card-heading">
                      <span className="subheading almost-white">
                        The Playbook
                      </span>
                        <br />
                        <br />
                      <span className="med-heading almost-white">
                        F*** It! And Keep Going
                      </span>
                    </div>
                  </div>
                  <div className="quest-card-back2 flip-card-back2">
                    <p className="text-box-s-c" style={{display: "flex", alignItems: "center"}}>
                      When confidence hits, you stop holding back. You go further.
                      Rouse is made for those f**k it moments — when you choose yourself, your desire, your pace.
                      <br />
                      <br />
                      Our mission? To liberate people in their own sexuality and create space for real, taboo-free intimacy.
                      Pleasure isn’t shameful, and thirst isn’t just physical.
                      <br />
                      <br />
                      P.S. Burnt-out planet? Not sexy. We care — a lot.
                    </p>
                  </div>
                </div>
              </div>
              <div className="quest-card5 flip-card2" style={{aspectRatio: windowWidth < 600 ? "1066/1800" : "13 / 16"}}>
                <div className="flip-card-inner2" >
                  <div className="quest-card-front2 flip-card-front2" >
                    <img className="card-image2 card-photo" src={windowWidth < 600 ? our_story2 : our_story} alt="" />
                    <div className="heading-wrap quest-card-heading">
                      <span className="subheading almost-white">
                        Elevator pitch
                      </span>
                        <br />
                        <br />
                      <span className="med-heading almost-white">
                        Hydration for More Enjoyment
                      </span>
                    </div>
                  </div>
                    <div className="quest-card-back2 flip-card-back2" >
                      <p className="text-box-s-c" style={{display: "flex", alignItems: "center"}}>
                     We started out as friends with benefits —
                      not exactly exclusive.
                      Always thirsty (in every sense),
                      and let’s be honest — water was never enough.
                      <br />
                      <br />
                      Now we’re in it together — husband and wife.<br />
                      And we wanted something better.
                      Something that keeps you going, helps you bounce back,
                      and supports the kind of intimacy that leaves you breathless.
                      <br />
                      <br />
                      Not a miracle. Just the right tool.<br />
                      So we created it:
                      the first rehydration drink designed for sex.

                      </p>
                    </div>
                </div>
              </div>
          </div>

          <div className="container-spacebetween" style={{paddingTop:"2.4rem", display: windowWidth < 600 ? "none" : "flex"}}>
              <div className="quest-card4 flip-card2" style={{aspectRatio:"1600/2240", }}>
                <div className="flip-card-inner2">
                  <div className="quest-card-front2 flip-card-front2" >
                    <img className="card-image2 card-photo" src={szilvi_2023} alt="" />
                  </div>
                  <div className="member-info flip-card-back2 info-text-c">
                  <span className="card-title mc-heading cards-team">
                      Szilvi
                    </span>
                    <p>
                      Co-Founder
                      <br />
                      <br />
                      Source of Funniest Ideas
                      <br />
                      <br />
                      The Muse
                    </p>
                  </div>
                </div>
              </div>

              <div className="quest-card4 flip-card2" style={{aspectRatio:"3194/4471", borderRadius: "6px"}}>
                <div className="flip-card-inner2">
                  <div className="quest-card-front2 flip-card-front2" style={{borderRadius: "6px", aspectRatio:"3194/4471"}}>
                    <img className="card-image2 card-photo" style={{aspectRatio:"1600/2399"}} src={akos_2023} alt="" />
                  </div>
                  <div className="member-info flip-card-back2 info-text-c">
                  <span className="card-title mc-heading cards-team">
                      Akos
                    </span>
                    <p>
                      Co-Founder
                      <br />
                      <br />
                      Top Dog
                      <br />
                      <br />
                      Problem Solver
                    </p>
                  </div>
                </div>
              </div>

              <div className="quest-card4 flip-card2" style={{aspectRatio:"3194/4471"}}>
                <div className="flip-card-inner2">
                  <div className="quest-card-front2 flip-card-front2" >
                    <img className="card-image2 card-photo" src={balint_2023} alt="" />
                  </div>
                    <div className="member-info flip-card-back2 info-text-c" >
                    <span className="card-title mc-heading cards-team">
                      Balint
                    </span>
                    <p>
                      Co-Founder
                      <br />
                      <br />
                      Creative Guru
                      <br />
                      <br />
                      The Help
                    </p>
                    </div>
                  </div>
                </div>

          </div>

        </div>
      </section>
    </SectionFadeIn>


      </motion.main>
  );

}

export default Quest;